import * as React from "react";
import { Button, styled } from "@mui/material";

const ButtonStyled = styled(Button)(({ theme }) => ({
  textTransform: "none",
  lineHeight: 1.2,
  fontSize: "14px",
  fontWeight: 400,
  padding: "8px 14px",
  backgroundColor: theme.palette.secondary.light,
  color: theme.palette.primary.main,
  minHeight: 40,
  boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2)",
  "&:active": {
    boxShadow: "0 1px 6px 0 rgba(0, 0, 0, 0.4)",
  },
  "&:hover": {
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.6)",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  "&.active": {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    boxShadow: "none",
  },
  "&.active:hover": {
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.4)",
  },
  "&:dir(rtl) .MuiButton-endIcon": {
    marginRight: 8,
    marginLeft: -4,
  },
}));

interface ContainedButtonProps {
  title?: string;
  style?: React.CSSProperties;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

const ContainedButton = ({ ...props }: ContainedButtonProps) => {
  return (
    <ButtonStyled
      title={props.title}
      style={props.style}
      onClick={props.onClick}
      disabled={props.disabled}
      className={props.className}
      variant={"contained"}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
    >
      {props.children}
    </ButtonStyled>
  );
};

export default ContainedButton;
